import { AlertTriangle } from 'lucide-react'
import { Link } from 'react-router'

/**
 * The ordering-pause alert, rendered IDENTICALLY everywhere the pause
 * surfaces (school Orders week view, checkout failures). Driven by the
 * outstanding-days endpoint's `blocked` flag; the server-side submit gate
 * stays the enforcement. `productionRecordsHref` points at the Production
 * Records page, where the Transport logs / Service records tasks that clear
 * the pause live (PROD-1277); omit it on that page itself.
 */
export function OrderingPausedBanner({ productionRecordsHref }: { productionRecordsHref?: string }) {
  return (
    <div className="flex w-full flex-wrap items-center gap-2 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-400">
      <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2} />
      <span>
        <span className="font-semibold">New orders are paused.</span> Complete your Production Records for past service
        days to resume ordering.
      </span>
      {productionRecordsHref ? (
        <Link to={productionRecordsHref} className="ml-auto shrink-0 font-medium underline underline-offset-2">
          Open Production Records
        </Link>
      ) : null}
    </div>
  )
}
